import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { InputHeader } from './header/InputHeader'
import { InputCore } from './core/InputCore'
import { VegaInputMultiple } from './multiple/InputMultiple'

/** A customizable vega input */
const VegaInput = forwardRef(
	(
		{
			className,
			onChange,
			onBlur,
			placeholder,
			label,
			link,
			value = '',
			name,
			errorMessage,
			disabled
		},
		ref
	) => {
		return (
			<div className={className}>
				<InputHeader label={label} link={link} />
				<InputCore
					ref={ref}
					name={name}
					placeholder={placeholder}
					value={value}
					errorMessage={errorMessage}
					disabled={disabled}
					onChange={onChange}
					onBlur={onBlur}
				/>
			</div>
		)
	}
)

VegaInput.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Set action on change */
	onChange: PropTypes.func,
	/** Set action on blur */
	onBlur: PropTypes.func,
	/** Set placeholder of input */
	placeholder: PropTypes.string,
	/** Set label on header of input */
	label: PropTypes.string,
	/** Set link on header of input */
	link: PropTypes.shape({
		label: PropTypes.string,
		onClick: PropTypes.func
	}),
	/** Set value of input */
	value: PropTypes.string,
	/** Set name of input */
	name: PropTypes.string,
	/** Set error message */
	errorMessage: PropTypes.string,
	/** Set disabled state */
	disabled: PropTypes.bool
}

export { VegaInput, VegaInputMultiple }
